import icons from "enums/icons";

export const paceData: { id: string; label: string; icon?: keyof typeof icons }[] = [
    {
        id: "all",
        label: "All (default)",
    },
    {
        id: "Completed",
        label: "Completed PACE",
        icon: "paceIconColouredDark",
    },
    {
        id: "Not Sharing",
        label: "Not Sharing PACE",
        icon: "paceIconNotShared",
    },
    {
        id: "Incomplete",
        label: "Incomplete PACE",
        icon: "paceIconGrayedOut",
    },
];

export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortable?: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "paceStatus" | "a-z" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "User",
        isHidable: false,
        isSortable: true,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: 200 },
    },
    {
        id: "pace_status",
        name: "Assessment Progress",
        isHidable: false,
        isSortable: true,
        sort: { isSortableByBestMatch: false, sortBy: "paceStatus" },
        sx: { width: 205 },
    },
    {
        id: "teams",
        name: "Teams",
        isHidable: false,
        isSortable: false,
        sx: { maxWidth: 100 },
    },
    {
        id: "lastContacted",
        name: "Last Contacted",
        isHidable: false,
        isSortable: false,
        sx: { width: 160 },
    },
    {
        id: "actions",
        name: "Actions",
        isHidable: false,
        isSortable: false,
        sx: { width: 175 },
    },
];
